module.exports = __webpack_public_path__ + "img/cb88460.webp";